import WorkOrders from '../components/WorkOrders';

const WorkOrderIndex: React.FC = () => {
  return <WorkOrders />;
};

export default WorkOrderIndex;
